//#region  import flags
import flagAU from '../assets/flags/flags/4x3/aus.svg' // Australia
import flagBM from '../assets/flags/flags/4x3/bmu.svg' // Bermuda
import flagCA from '../assets/flags/flags/4x3/can.svg' // Canada
import flagCH from '../assets/flags/flags/4x3/che.svg' // Switzerland
import flagCY from '../assets/flags/flags/4x3/cyp.svg' // Cyprus
import flagDE from '../assets/flags/flags/4x3/deu.svg' // Germany
import flagGB from "../assets/flags/flags/4x3/gbr.svg" // United Kingdom
import flagES from "../assets/flags/flags/4x3/esp.svg" // Spain
import flagFI from "../assets/flags/flags/4x3/fin.svg" // Finland
import flagFR from "../assets/flags/flags/4x3/fra.svg" // France
import flagGG from "../assets/flags/flags/4x3/ggy.svg" // Guernsey
import flagGI from "../assets/flags/flags/4x3/gib.svg" // Gibraltar
import flagHK from "../assets/flags/flags/4x3/hkg.svg" // Hong Kong
import flagIE from "../assets/flags/flags/4x3/irl.svg" // Ireland
import flagIL from "../assets/flags/flags/4x3/isr.svg" // Israel
import flagIT from "../assets/flags/flags/4x3/ita.svg" // Italy
import flagIM from "../assets/flags/flags/4x3/imn.svg" // Isle of Man
import flagJE from "../assets/flags/flags/4x3/jey.svg" // Jersey
import flagKY from "../assets/flags/flags/4x3/cym.svg" // Cayman Islands
import flagLU from "../assets/flags/flags/4x3/lux.svg" // Luxembourg
import flagMY from "../assets/flags/flags/4x3/mys.svg" // Malaysia
import flagNL from "../assets/flags/flags/4x3/nld.svg" // Netherlands
import flagSG from "../assets/flags/flags/4x3/sgp.svg" // Singapore
import flagUS from "../assets/flags/flags/4x3/usa.svg" // United States
import flagVG from "../assets/flags/flags/4x3/vgb.svg" // Virgin Islands (British)
import flagZA from "../assets/flags/flags/4x3/zaf.svg" // South Africa
import flagZM from "../assets/flags/flags/4x3/zmb.svg" // Zambia
//#endregion  import flags

export const COUNTRY = {
  0: {},// country: "",nationality: "", code: "" },
  4: { country: "Afghanistan", nationality: "Afghan", code: "AF" },
  248: { country: "Ã…land Islands", nationality: "Ã…lander", code: "AX" },
  8: { country: "Albania", nationality: "Albanian", code: "AL" },
  12: { country: "Algeria", nationality: "Algerian", code: "DZ" },
  16: { country: "American Samoa", nationality: "", code: "AS" },
  20: { country: "Andorra", nationality: "Andorran", code: "AD" },
  24: { country: "Angola", nationality: "Angolan", code: "AO" },
  660: { country: "Anguilla", nationality: "Anguillan", code: "AI" },
  10: { country: "Antarctica", nationality: "", code: "AQ" },
  28: { country: "Antigua & Barbuda", nationality: "Citizen of Antigua & Barbuda", code: "AG" },
  32: { country: "Argentina", nationality: "Argentine", code: "AR" },
  51: { country: "Armenia", nationality: "Armenian", code: "AM" },
  533: { country: "Aruba", nationality: "", code: "AW" },
  36: { country: "Australia", nationality: "Australian", code: "AU" },
  40: { country: "Austria", nationality: "Austrian", code: "AT" },
  31: { country: "Azerbaijan", nationality: "Azerbaijani", code: "AZ" },
  44: { country: "Bahamas", nationality: "Bahamian", code: "BS" },
  48: { country: "Bahrain", nationality: "Bahraini", code: "BH" },
  50: { country: "Bangladesh", nationality: "Bangladeshi", code: "BD" },
  52: { country: "Barbados", nationality: "Barbadian", code: "BB" },
  112: { country: "Belarus", nationality: "Belarusian", code: "BY" },
  56: { country: "Belgium", nationality: "Belgian", code: "BE" },
  84: { country: "Belize", nationality: "Belizean", code: "BZ" },
  204: { country: "Benin", nationality: "Beninese", code: "BJ" },
  60: { country: "Bermuda", nationality: "Bermudian", code: "BM" },
  64: { country: "Bhutan", nationality: "Bhutanese", code: "BT" },
  68: { country: "Bolivia", nationality: "Bolivian", code: "BO" },
  535: { country: "Bonaire, Sint Eustatius & Saba", nationality: "", code: "BQ" },
  70: { country: "Bosnia & Herzegovina", nationality: "Citizen of Bosnia & Herzegovina", code: "BA" },
  72: { country: "Botswana", nationality: "Botswanan", code: "BW" },
  74: { country: "Bouvet Island", nationality: "", code: "BV" },
  76: { country: "Brazil", nationality: "Brazilian", code: "BR" },
  86: { country: "British Indian Ocean Territory", nationality: "", code: "IO" },
  96: { country: "Brunei", nationality: "Bruneian", code: "BN" },
  100: { country: "Bulgaria", nationality: "Bulgarian", code: "BG" },
  854: { country: "Burkina Faso", nationality: "Burkinan", code: "BF" },
  108: { country: "Burundi", nationality: "Burundian", code: "BI" },
  132: { country: "Cape Verde", nationality: "Cape Verdean", code: "CV" },
  116: { country: "Cambodia", nationality: "Cambodian", code: "KH" },
  120: { country: "Cameroon", nationality: "Cameroonian", code: "CM" },
  124: { country: "Canada", nationality: "Canadian", code: "CA" },
  136: { country: "Cayman Islands", nationality: "Cayman Islander", code: "KY" },
  140: { country: "Central African Republic", nationality: "Central African", code: "CF" },
  148: { country: "Chad", nationality: "Chadian", code: "TD" },
  152: { country: "Chile", nationality: "Chilean", code: "CL" },
  156: { country: "China", nationality: "Chinese", code: "CN" },
  162: { country: "Christmas Island", nationality: "", code: "CX" },
  166: { country: "Cocos (Keeling) Islands", nationality: "", code: "CC" },
  170: { country: "Colombia", nationality: "Colombian", code: "CO" },
  174: { country: "Comoros", nationality: "Comoran", code: "KM" },
  180: { country: "Congo (Democratic Republic of)", nationality: "Congolese (DRC)", code: "CD" },
  178: { country: "Congo", nationality: "Congolese (Congo)", code: "CG" },
  184: { country: "Cook Islands", nationality: "Cook Islander", code: "CK" },
  188: { country: "Costa Rica", nationality: "Costa Rican", code: "CR" },
  384: { country: "Ivory Coast", nationality: "Ivorian", code: "CI" },
  191: { country: "Croatia", nationality: "Croatian", code: "HR" },
  192: { country: "Cuba", nationality: "Cuban", code: "CU" },
  531: { country: "CuraÃ§ao", nationality: "Cymraes", code: "CW" },
  196: { country: "Cyprus", nationality: "Cypriot", code: "CY" },
  203: { country: "Czech Republic", nationality: "Czech", code: "CZ" },
  208: { country: "Denmark", nationality: "Danish", code: "DK" },
  262: { country: "Djibouti", nationality: "Djiboutian", code: "DJ" },
  212: { country: "Dominica", nationality: "Dominican", code: "DM" },
  214: { country: "Dominican Republic", nationality: "Citizen of the Dominican Republic", code: "DO" },
  218: { country: "Ecuador", nationality: "Ecuadorean", code: "EC" },
  818: { country: "Egypt", nationality: "Egyptian", code: "EG" },
  222: { country: "El Salvador", nationality: "Salvadorean", code: "SV" },
  226: { country: "Equatorial Guinea", nationality: "Equatorial Guinean", code: "GQ" },
  232: { country: "Eritrea", nationality: "Eritrean", code: "ER" },
  233: { country: "Estonia", nationality: "Estonian", code: "EE" },
  748: { country: "Eswatini", nationality: "Swazi", code: "SZ" },
  231: { country: "Ethiopia", nationality: "Ethiopian", code: "ET" },
  238: { country: "Falkland Islands", nationality: "", code: "FK" },
  234: { country: "Faroe Islands", nationality: "Faroese", code: "FO" },
  242: { country: "Fiji", nationality: "Fijian", code: "FJ" },
  246: { country: "Finland", nationality: "Finnish", code: "FI" },
  250: { country: "France", nationality: "French", code: "FR" },
  254: { country: "French Guiana", nationality: "", code: "GF" },
  258: { country: "French Polynesia", nationality: "", code: "PF" },
  260: { country: "French Southern Territories", nationality: "", code: "TF" },
  266: { country: "Gabon", nationality: "Gabonese", code: "GA" },
  270: { country: "Gambia", nationality: "Gambian", code: "GM" },
  268: { country: "Georgia", nationality: "Georgian", code: "GE" },
  276: { country: "Germany", nationality: "German", code: "DE" },
  288: { country: "Ghana", nationality: "Ghanaian", code: "GH" },
  292: { country: "Gibraltar", nationality: "Gibraltarian", code: "GI" },
  300: { country: "Greece", nationality: "Greek", code: "GR" },
  304: { country: "Greenland", nationality: "Greenlandic", code: "GL" },
  308: { country: "Grenada", nationality: "Grenadian", code: "GD" },
  312: { country: "Guadeloupe", nationality: "", code: "GP" },
  316: { country: "Guam", nationality: "Guamanian", code: "GU" },
  320: { country: "Guatemala", nationality: "Guatemalan", code: "GT" },
  831: { country: "Guernsey", nationality: "", code: "GG" },
  324: { country: "Guinea", nationality: "Guinean", code: "GN" },
  624: { country: "Guinea-Bissau", nationality: "Citizen of Guinea-Bissau", code: "GW" },
  328: { country: "Guyana", nationality: "Guyanese", code: "GY" },
  332: { country: "Haiti", nationality: "Haitian", code: "HT" },
  334: { country: "Heard Island & McDonald Islands", nationality: "", code: "HM" },
  336: { country: "Vatican City", nationality: "Vatican citizen", code: "VA" },
  340: { country: "Honduras", nationality: "Honduran", code: "HN" },
  344: { country: "Hong Kong", nationality: "Hong Konger", code: "HK" },
  348: { country: "Hungary", nationality: "Hungarian", code: "HU" },
  352: { country: "Iceland", nationality: "Icelandic", code: "IS" },
  356: { country: "India", nationality: "Indian", code: "IN" },
  360: { country: "Indonesia", nationality: "Indonesian", code: "ID" },
  364: { country: "Iran", nationality: "Iranian", code: "IR" },
  368: { country: "Iraq", nationality: "Iraqi", code: "IQ" },
  372: { country: "Ireland", nationality: "Irish", code: "IE" },
  833: { country: "Isle of Man", nationality: "", code: "IM" },
  376: { country: "Israel", nationality: "Israeli", code: "IL" },
  380: { country: "Italy", nationality: "Italian", code: "IT" },
  388: { country: "Jamaica", nationality: "Jamaican", code: "JM" },
  392: { country: "Japan", nationality: "Japanese", code: "JP" },
  832: { country: "Jersey", nationality: "", code: "JE" },
  400: { country: "Jordan", nationality: "Jordanian", code: "JO" },
  398: { country: "Kazakhstan", nationality: "Kazakh", code: "KZ" },
  404: { country: "Kenya", nationality: "Kenyan", code: "KE" },
  296: { country: "Kiribati", nationality: "Citizen of Kiribati", code: "KI" },
  408: { country: "Korea (Democratic People's Republic of)", nationality: "North Korean", code: "KP" },
  410: { country: "Korea (Republic of)", nationality: "South Korean", code: "KR" },
  414: { country: "Kuwait", nationality: "Kuwaiti", code: "KW" },
  417: { country: "Kyrgyzstan", nationality: "Kyrgyz", code: "KG" },
  418: { country: "Laos", nationality: "Lao", code: "LA" },
  428: { country: "Latvia", nationality: "Latvian", code: "LV" },
  422: { country: "Lebanon", nationality: "Lebanese", code: "LB" },
  426: { country: "Lesotho", nationality: "Mosotho", code: "LS" },
  430: { country: "Liberia", nationality: "Liberian", code: "LR" },
  434: { country: "Libya", nationality: "Libyan", code: "LY" },
  438: { country: "Liechtenstein", nationality: "Liechtenstein citizen", code: "LI" },
  440: { country: "Lithuania", nationality: "Lithuanian", code: "LT" },
  442: { country: "Luxembourg", nationality: "Luxembourger", code: "LU" },
  446: { country: "Macao", nationality: "Macanese", code: "MO" },
  450: { country: "Madagascar", nationality: "Malagasy", code: "MG" },
  454: { country: "Malawi", nationality: "Malawian", code: "MW" },
  458: { country: "Malaysia", nationality: "Malaysian", code: "MY" },
  462: { country: "Maldives", nationality: "Maldivian", code: "MV" },
  466: { country: "Mali", nationality: "Malian", code: "ML" },
  470: { country: "Malta", nationality: "Maltese", code: "MT" },
  584: { country: "Marshall Islands", nationality: "Marshallese", code: "MH" },
  474: { country: "Martinique", nationality: "Martiniquais", code: "MQ" },
  478: { country: "Mauritania", nationality: "Mauritanian", code: "MR" },
  480: { country: "Mauritius", nationality: "Mauritian", code: "MU" },
  175: { country: "Mayotte", nationality: "", code: "YT" },
  484: { country: "Mexico", nationality: "Mexican", code: "MX" },
  583: { country: "Micronesia", nationality: "Micronesian", code: "FM" },
  498: { country: "Moldova", nationality: "Moldovan", code: "MD" },
  492: { country: "Monaco", nationality: "Monegasque/MonÃ©gasque ", code: "MC" },
  496: { country: "Mongolia", nationality: "Mongolian", code: "MN" },
  499: { country: "Montenegro", nationality: "Montenegrin", code: "ME" },
  500: { country: "Montserrat", nationality: "Montserratian", code: "MS" },
  504: { country: "Morocco", nationality: "Moroccan", code: "MA" },
  508: { country: "Mozambique", nationality: "Mozambican", code: "MZ" },
  104: { country: "Myanmar", nationality: "Burmese", code: "MM" },
  516: { country: "Namibia", nationality: "Namibian", code: "NA" },
  520: { country: "Nauru", nationality: "Nauruan", code: "NR" },
  524: { country: "Nepal", nationality: "Nepalese", code: "NP" },
  528: { country: "Netherlands", nationality: "Dutch", code: "NL" },
  540: { country: "New Caledonia", nationality: "", code: "NC" },
  554: { country: "New Zealand", nationality: "New Zealander", code: "NZ" },
  558: { country: "Nicaragua", nationality: "Nicaraguan", code: "NI" },
  562: { country: "Niger", nationality: "Nigerien", code: "NE" },
  566: { country: "Nigeria", nationality: "Nigerian", code: "NG" },
  570: { country: "Niue", nationality: "Niuean", code: "NU" },
  574: { country: "Norfolk Island", nationality: "", code: "NF" },
  580: { country: "Northern Mariana Islands", nationality: "", code: "MP" },
  578: { country: "Norway", nationality: "Norwegian", code: "NO" },
  512: { country: "Oman", nationality: "Omani", code: "OM" },
  586: { country: "Pakistan", nationality: "Pakistani", code: "PK" },
  585: { country: "Palau", nationality: "Palauan", code: "PW" },
  275: { country: "Palestine", nationality: "Palestinian", code: "PS" },
  591: { country: "Panama", nationality: "Panamanian", code: "PA" },
  598: { country: "Papua New Guinea", nationality: "Papua New Guinean", code: "PG" },
  600: { country: "Paraguay", nationality: "Paraguayan", code: "PY" },
  604: { country: "Peru", nationality: "Peruvian", code: "PE" },
  608: { country: "Philippines", nationality: "Filipino", code: "PH" },
  612: { country: "Pitcairn", nationality: "Pitcairn Islander", code: "PN" },
  616: { country: "Poland", nationality: "Polish", code: "PL" },
  620: { country: "Portugal", nationality: "Portuguese", code: "PT" },
  630: { country: "Puerto Rico", nationality: "Puerto Rican", code: "PR" },
  634: { country: "Qatar", nationality: "Qatari", code: "QA" },
  807: { country: "North Macedonia", nationality: "Macedonian", code: "MK" },
  638: { country: "RÃ©union", nationality: "", code: "RE" },
  642: { country: "Romania", nationality: "Romanian", code: "RO" },
  643: { country: "Russia", nationality: "Russian", code: "RU" },
  646: { country: "Rwanda", nationality: "Rwandan", code: "RW" },
  652: { country: "Saint BarthÃ©lemy", nationality: "", code: "BL" },
  654: { country: "Saint Helena, Ascension & Tristan da Cunha", nationality: "St Helenian", code: "SH" },
  659: { country: "Saint Kitts & Nevis", nationality: "Kittitian", code: "KN" },
  662: { country: "Saint Lucia", nationality: "St Lucian", code: "LC" },
  663: { country: "Saint Martin (French part)", nationality: "", code: "MF" },
  666: { country: "Saint Pierre & Miquelon", nationality: "", code: "PM" },
  670: { country: "Saint Vincent & the Grenadines", nationality: "Vincentian", code: "VC" },
  882: { country: "Samoa", nationality: "Samoan", code: "WS" },
  674: { country: "San Marino", nationality: "Sammarinese", code: "SM" },
  678: { country: "Sao Tome & Principe", nationality: "Sao Tomean", code: "ST" },
  682: { country: "Saudi Arabia", nationality: "Saudi Arabian", code: "SA" },
  686: { country: "Senegal", nationality: "Senegalese", code: "SN" },
  688: { country: "Serbia", nationality: "Serbian", code: "RS" },
  690: { country: "Seychelles", nationality: "Citizen of Seychelles", code: "SC" },
  694: { country: "Sierra Leone", nationality: "Sierra Leonean", code: "SL" },
  702: { country: "Singapore", nationality: "Singaporean", code: "SG" },
  534: { country: "Sint Maarten (Dutch part)", nationality: "", code: "SX" },
  703: { country: "Slovakia", nationality: "Slovak", code: "SK" },
  705: { country: "Slovenia", nationality: "Slovenian", code: "SI" },
  90: { country: "Solomon Islands", nationality: "Solomon Islander", code: "SB" },
  706: { country: "Somalia", nationality: "Somali", code: "SO" },
  710: { country: "South Africa", nationality: "South African", code: "ZA" },
  239: { country: "South Georgia & South Sandwich Islands", nationality: "", code: "GS" },
  728: { country: "South Sudan", nationality: "South Sudanese", code: "SS" },
  724: { country: "Spain", nationality: "Spanish", code: "ES" },
  144: { country: "Sri Lanka", nationality: "Sri Lankan", code: "LK" },
  729: { country: "Sudan", nationality: "Sudanese", code: "SD" },
  740: { country: "Suriname", nationality: "Surinamese", code: "SR" },
  744: { country: "Svalbard & Jan Mayen", nationality: "", code: "SJ" },
  752: { country: "Sweden", nationality: "Swedish", code: "SE" },
  756: { country: "Switzerland", nationality: "Swiss", code: "CH" },
  760: { country: "Syrian Arab Republic", nationality: "Syrian", code: "SY" },
  158: { country: "Taiwan", nationality: "Taiwanese", code: "TW" },
  762: { country: "Tajikistan", nationality: "Tajik", code: "TJ" },
  834: { country: "Tanzania", nationality: "Tanzanian", code: "TZ" },
  764: { country: "Thailand", nationality: "Thai", code: "TH" },
  626: { country: "Timor-Leste", nationality: "East Timorese", code: "TL" },
  768: { country: "Togo", nationality: "Togolese", code: "TG" },
  772: { country: "Tokelau", nationality: "", code: "TK" },
  776: { country: "Tonga", nationality: "Tongan", code: "TO" },
  780: { country: "Trinidad & Tobago", nationality: "Trinidadian", code: "TT" },
  788: { country: "Tunisia", nationality: "Tunisian", code: "TN" },
  792: { country: "Turkey", nationality: "Turkish", code: "TR" },
  795: { country: "Turkmenistan", nationality: "Turkmen", code: "TM" },
  796: { country: "Turks & Caicos Islands", nationality: "Turks & Caicos Islander", code: "TC" },
  798: { country: "Tuvalu", nationality: "Tuvaluan", code: "TV" },
  800: { country: "Uganda", nationality: "Ugandan", code: "UG" },
  804: { country: "Ukraine", nationality: "Ukrainian", code: "UA" },
  784: { country: "United Arab Emirates", nationality: "Emirati", code: "AE" },
  826: { country: "United Kingdom", nationality: "British", code: "GB" },
  840: { country: "United States", nationality: "American", code: "US" },
  581: { country: "United States Minor Outlying Islands", nationality: "", code: "UM" },
  858: { country: "Uruguay", nationality: "Uruguayan", code: "UY" },
  860: { country: "Uzbekistan", nationality: "Uzbek", code: "UZ" },
  548: { country: "Vanuatu", nationality: "Citizen of Vanuatu ", code: "VU" },
  862: { country: "Venezuela", nationality: "Venezuelan", code: "VE" },
  704: { country: "Vietnam", nationality: "Vietnamese", code: "VN" },
  92: { country: "British Virgin Islands", nationality: "British Virgin Islander", code: "VG" },
  850: { country: "U.S. Virgin Islands", nationality: "", code: "VI" },
  876: { country: "Wallis & Futuna", nationality: "Wallisian", code: "WF" },
  732: { country: "Western Sahara", nationality: "", code: "EH" },
  887: { country: "Yemen", nationality: "Yemeni", code: "YE" },
  894: { country: "Zambia", nationality: "Zambian", code: "ZM" },
  716: { country: "Zimbabwe", nationality: "Zimbabwean", code: "ZW" },

  1826: { country: "England", nationality: "British", code: "GB-ENG" },
  2826: { country: "Scotland", nationality: "British", code: "GB-SCT" },
  3826: { country: "Wales", nationality: "British", code: "GB-WLS" },
  4826: { country: "Northern Ireland", nationality: "British", code: "GB-NIR" },
  5826: { country: "Sark", nationality: "British", code: "GB-SAR" },
  6826: { country: "Alderney", nationality: "British", code: "GB-ALD" },

  AU: { name: "Australia", flag: flagAU },
  BM: { name: "Bermuda", flag: flagBM },
  CA: { name: "Canada", flag: flagCA },
  CH: { name: "Switzerland", flag: flagCH },
  CY: { name: "Cyprus", flag: flagCY },
  DE: { name: "Germany", flag: flagDE },
  ES: { name: "Spain", flag: flagES },
  FI: { name: "Finland", flag: flagFI },
  FR: { name: "France", flag: flagFR },
  GB: { name: "United Kingdom", flag: flagGB },
  GG: { name: "Guernsey", flag: flagGG },
  GI: { name: "Gibraltar", flag: flagGI },
  HK: { name: "Hong Kong", flag: flagHK },
  IE: { name: "Ireland", flag: flagIE },
  IL: { name: "Israel", flag: flagIL },
  IM: { name: "Isle of Man", flag: flagIM },
  IT: { name: "Italy", flag: flagIT },
  JE: { name: "Jersey", flag: flagJE },
  KY: { name: "Cayman Islands", flag: flagKY },
  LU: { name: "Luxembourg", flag: flagLU },
  MY: { name: "Malaysia", flag: flagMY },
  NL: { name: "Netherlands", flag: flagNL },
  SG: { name: "Singapore", flag: flagSG },
  US: { name: "United States", flag: flagUS },
  VG: { name: "Virgin Islands (British)", flag: flagVG },
  ZA: { name: "South Africa", flag: flagZA },
  ZM: { name: "Zambia", flag: flagZM },
}

// // Create complimmentary objects using the country codes with flag
// // eg COUNTRY[GB] = { name: "United Kingdom",  flag: flagGB },
// for (const [key, value] of Object.entries(COUNTRY)) {
//   COUNTRY[value.code] = {
//     name: COUNTRY[key].country,
//     flag: `flag${value.code}`,
//   }
//   // console.log(`${value.code}: ${ COUNTRY[value.code].name}  ${ COUNTRY[value.code].flag}`);
// }

